import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";

export default function EuropassPdfHobbiesSection( { resumeData, translations } ) {
    const { hobbies } = extractResumeDataDocumentSection( resumeData );

    const styles = StyleSheet.create( {
        sectionCompetence: {
            flexDirection: 'row',
            flexWrap: 'wrap',
        },
        lineTitle: {
            height: 1,
            backgroundColor: "#979797",
            marginRight: 10,
            marginBottom: 5,
        },
        loisir: {
            fontSize: 8,
            marginRight: 2,
        }
    } );

    return (
        <View style={ { marginTop: 20, paddingHorizontal: 20, marginRight: 40 } }>
            <View style={ { flexDirection: "row", marginBottom: 4 } }>
                <Text style={ { fontSize: 11, marginRight: 3 } }>•</Text>
                <Text style={ { fontWeight: "bold", textTransform: "uppercase", fontSize: 9, marginTop: 2 } }>
                    { translations.pdf.hobbiesTitle }
                </Text>
            </View>
            <View style={ [ styles.lineTitle, { marginTop: 1 } ] }/>
            <View style={ styles.sectionCompetence }>
                <Text style={ styles.loisir }>
                    { hobbies
                        .filter( hobby => hobby.text && hobby.text !== '' )
                        .sort( ( a, b ) => a.order - b.order )
                        .map( hobby => hobby.text )
                        .join( ', ' ) }
                </Text>
            </View>
        </View>
    );
}